export enum FeeType {
  AUTOMATIC,
  FEE
}
